const SDK_VERSION = '7.101.1';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
